// Centralized action type constants for request files form
export const ACTIONS = {
  // Generic
  SET_FIELD: 'SET_FIELD',
  INITIALIZE_FORM: 'INITIALIZE_FORM',
  RESET_FORM: 'RESET_FORM',

  // Auth
  SET_AUTH_TYPE: 'SET_AUTH_TYPE',
  SET_SECRET_QUESTIONS: 'SET_SECRET_QUESTIONS',
  UPDATE_SECRET_QUESTION: 'UPDATE_SECRET_QUESTION',

  // Client / Selection
  SET_CLIENT: 'SET_CLIENT',
  SET_SELECTED_FOLDER: 'SET_SELECTED_FOLDER',

  // Email
  ADD_RECIPIENT: 'ADD_RECIPIENT',
  REMOVE_RECIPIENT: 'REMOVE_RECIPIENT',
  UPDATE_RECIPIENT: 'UPDATE_RECIPIENT',
  ADD_RECEIVER: 'ADD_RECEIVER',
  REMOVE_RECEIVER: 'REMOVE_RECEIVER',
  UPDATE_RECEIVER: 'UPDATE_RECEIVER',
  SET_EMAIL_RESULTS: 'SET_EMAIL_RESULTS',
  TOGGLE_SEND_EMAILS: 'TOGGLE_SEND_EMAILS',
  TOGGLE_RECEIVE_EMAILS: 'TOGGLE_RECEIVE_EMAILS',

  // Template / Task
  SET_REQUEST_TEMPLATE: 'SET_REQUEST_TEMPLATE',
  SET_TEMPLATE_DOCUMENTS: 'SET_TEMPLATE_DOCUMENTS',
  SET_DATE_RANGE: 'SET_DATE_RANGE',
  SET_DUE_DATE: 'SET_DUE_DATE',
  TOGGLE_DOCUMENT_SELECTION: 'TOGGLE_DOCUMENT_SELECTION',
  ADD_OTHER_INPUT: 'ADD_OTHER_INPUT',
  REMOVE_OTHER_INPUT: 'REMOVE_OTHER_INPUT',
  UPDATE_OTHER_INPUT: 'UPDATE_OTHER_INPUT',
  SET_PER_DOCUMENT_DATE: 'SET_PER_DOCUMENT_DATE',
  SET_PER_OTHER_INPUT_DATE: 'SET_PER_OTHER_INPUT_DATE',
  SET_SPECIAL_INSTRUCTIONS: 'SET_SPECIAL_INSTRUCTIONS',
  ADD_ASSIGNEE: 'ADD_ASSIGNEE',
  REMOVE_ASSIGNEE: 'REMOVE_ASSIGNEE',
  UPDATE_ASSIGNEE: 'UPDATE_ASSIGNEE',
  UPDATE_ASSIGNEE_FIELD: 'UPDATE_ASSIGNEE_FIELD',

  // UI
  SET_SUBMITTING: 'SET_SUBMITTING',
  SET_COPY_SUCCESS: 'SET_COPY_SUCCESS',
}

export default ACTIONS
